import { useQuery } from 'react-query';
import axios from 'axios';

import config from '../../config';

const getBillingData = () =>
  axios.get(`${config?.apiHost}/v1/billing/info`, { withCredentials: true });

const getEligiblePlans = () =>
  axios.get(`${config?.apiHost}/v1/plans/eligible`, { withCredentials: true });

export const useGetBillingData = () => useQuery(['billingData'], getBillingData);
export const useGetEligiblePlans = () => useQuery(['eligiblePlans'], getEligiblePlans);



// WEBPACK FOOTER //
// ./src/hooks/react-query/useBillingData.js